import { NgModule } from '@angular/core';
import { FbqGgOrderPlacedEventBuilder } from './fbq-gg-order-placed-event.builder';

@NgModule({})
export class FbqGgOrderPlacedEventModule {
  constructor(_ggOrderPlacedEventBuilder: FbqGgOrderPlacedEventBuilder) {}
}
